import styled from 'styled-components';

export const SectionTitle = styled.p(({ theme }) => ({
  marginLeft: '20rem',
  fontSize: theme.typography.size16,
  fontFamily: theme.typography.family.arial,
  color: theme.palette.dimGray,
}));
